<template>
	<div class="homework-row">
		<label>
			{{ 'Game type' | translate }}
			<select v-model="config.type" class="form-control">
				<option :value="type.value" v-for="(type, index) in gameTypes" :key="index">
					{{ type.label | translate }}
				</option>
			</select>
		</label>

		<label>
			{{ 'Calculation method' | translate }}
			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="oral" />
					{{ 'Imaginary abacus' | translate }}
				</label>
			</div>

			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="abacus" />
					{{ 'Abacus' | translate }}
				</label>
			</div>
		</label>

		<label>
			{{ 'Level' | translate }}
			<select required v-model="config.options.type" class="form-control">
				<option :value="digit.value" v-for="(digit, index) in anzanType" :key="index">
					{{ $t(digit.label).toLowerCase() }}
				</option>
			</select>
		</label>
		<label>
			{{ 'Calculation method' | translate }}
			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="oral" />
					{{ 'Imaginary abacus' | translate }}
				</label>
			</div>
			<div class="form-check">
				<label class="form-check-label">
					<input class="form-check-input" type="radio" v-model="config.options.calculation_method" value="abacus" />
					{{ 'Abacus' | translate }}
				</label>
			</div>
		</label>
		<label>
			{{ 'Complexity' | translate }}
			<select required v-model="config.options.places" class="form-control">
				<option :value="difficult" v-for="(difficult, index) in difficult" :key="index">
					{{ difficult }}
				</option>
			</select>
		</label>

		<!-- <label>
			{{ 'Speed' | translate }}
			<input required type="number" step="0.1" max="10" min="0" :value="config.options.speed" @input="onChangeSpeed"
				@blur="onBlurSpeed" class="form-control" />
		</label>
		<label>
			{{ 'Action with numbers' | translate }}
			<input required type="number" min="3" step="1" max="25" :value="config.options.length" @input="onChangeLength"
				@blur="onBlurLength" class="form-control" />
		</label> -->

		<label>
			{{ 'Speed' | translate }}
			<input required type="number" step="0.1" max="10" min="0.1" v-model="config.options.speed" @blur="onBlurSpeed"
				class="form-control" />
		</label>

		<label>
			{{ 'Action with numbers' | translate }}
			<input required type="number" min="1" step="1" max="25" v-model="config.options.length" @blur="onBlurLength"
				class="form-control" />
		</label>

		<label>
			{{ 'Number of expressions' | translate }}
			<input type="number" :value="config.repeat" @input="onInputRepeat" @blur="onBlurRepeat" min="1" max="10" step="1"
				class="form-control" />
		</label>
	</div>
</template>

<script>
import { DEFAULT_ANZAN_OPTIONS } from '../Create.vue'
import {
	LABELED_ADDITION_TYPES,
	PLACES,
	getAdditionalDigits,
} from '../../../Games/gameConfig'

export default {
	name: 'anzan',
	props: {
		config: Object,
		onBlurRepeat: Function,
		onInputRepeat: Function,
		gameTypes: Array,
	},
	created() {
		if (this.config.id || this.config.is_created) {
			this.config.id = undefined
			// this.config.is_created = true

			if (!this.config.options.digit || !this.config.options.places || !this.config.options.type || this.config.options.type == 'abacus_random_2') {
				this.config.options = { ...DEFAULT_ANZAN_OPTIONS }
			}
		} else {
			// small super-fast fix for make new config object
			this.config.options = { ...DEFAULT_ANZAN_OPTIONS }
		}

		this.config.is_created = true

		// if (this.config.id) {
		// 	this.config.id = undefined
		// } else {
		// 	this.config.options = { ...DEFAULT_ANZAN_OPTIONS }
		// }
	},
	methods: {
		onChangeLength({ target }) {
			const {
				value,
				validity: { valid },
			} = target
			this.config.options.length =
				value && !valid ? this.config.options.length : value
			target.value = this.config.options.length
		},
		onBlurLength() {
			if (
				!this.config.options.length ||
				Number(this.config.options.length <= 3)
			) {
				this.config.options.length = 3
			}
		},
		onChangeSpeed({ target }) {
			const {
				value,
				validity: { valid },
			} = target
			this.config.options.speed =
				value && !valid ? this.config.options.speed : value
			target.value = this.config.options.speed
		},
		onBlurSpeed() {
			if (
				!this.config.options.speed ||
				Number(this.config.options.speed <= 0.1)
			) {
				this.config.options.speed = 0.1
			}
		},
	},
	computed: {
		anzanType() {
			return [
				{ value: 'anzan_random', label: 'Random numbers' },
				{ value: 'anzan_minus', label: 'Only subtraction' },
				{ value: 'anzan_plus', label: 'Only add' },
			]
		},
		difficult() {
			return PLACES
		},
		digits() {
			const { type, places } = this.config.options
			return getAdditionalDigits(type, +places)
		},
	},
}
</script>
